/* Dr.Primal — accordion.
   The accordion is native <details>/<summary>, so it opens and closes with no JS at
   all. This file adds one behaviour on top: within a group, only one panel stays open.
   The chevron rotation is pure CSS on details[open]. */
(function () {
  'use strict';

  function bind(group) {
    if (group.getAttribute('data-dp-accordion-ready') === 'true') return;
    group.setAttribute('data-dp-accordion-ready', 'true');

    var items = group.querySelectorAll(':scope > details');

    Array.prototype.forEach.call(items, function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        Array.prototype.forEach.call(items, function (other) {
          /* A sibling dp-details-motion.js is already easing shut is left to finish. */
          if (other !== item && other.open && !other.hasAttribute('data-dp-motion-closing')) {
            other.open = false;
          }
        });
      });
    });
  }

  function init() {
    var groups = document.querySelectorAll('[data-dp-accordion]');
    Array.prototype.forEach.call(groups, bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
